import { render, staticRenderFns } from "./ArvoreDinamica.vue?vue&type=template&id=0b195e17&scoped=true"
import script from "./ArvoreDinamica.vue?vue&type=script&lang=js"
export * from "./ArvoreDinamica.vue?vue&type=script&lang=js"
import style0 from "./ArvoreDinamica.vue?vue&type=style&index=0&id=0b195e17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b195e17",
  null
  
)

export default component.exports